import { Progress } from "@/components/ui/progress";

type Props = {
  done: number;
  total: number;
  className?: string;
};

export function JourneyProgressBar({ done, total, className }: Props) {
  const pct = total > 0 ? Math.round((done / total) * 100) : 0;
  return (
    <div className={className}>
      <div className="mb-2 flex items-center justify-between">
        <p className="text-sm font-medium">Your progress</p>
        <span className="font-display text-lg font-semibold tabular-nums">
          {pct}%
        </span>
      </div>
      <Progress value={pct} />
      <p className="mt-2 text-xs text-muted-foreground">
        {done} of {total} {total === 1 ? "task" : "tasks"} complete
      </p>
    </div>
  );
}
